import { useEffect, useRef } from 'react';

/**
 * Runs `init` once per modal open + sessionKey.
 * Background CRM refreshes recreate derived lists (e.g. selectableClients) but must not
 * wipe in-progress form input.
 */
export function useModalFormSession(
  open: boolean,
  sessionKey: string,
  init: () => void,
): void {
  const initializedKeyRef = useRef<string | null>(null);

  useEffect(() => {
    if (!open) {
      initializedKeyRef.current = null;
      return;
    }
    if (initializedKeyRef.current === sessionKey) return;
    initializedKeyRef.current = sessionKey;
    init();
  }, [open, sessionKey, init]);
}
